import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { glyphs, useMediaQuery } from "../../../Styles";
import { Button, ProgressSteps, NewModal, MainContentPaddingTypes } from "../..";

//TODO
import { ReportTemplate } from "../../../Definitions/valueTypes";
import TemplateModalLvl1 from "./templateModalLvl1";
import TemplateModalLvl2 from "./templateModalLvl2";
import TemplateModalLvl3 from "./templateModalLvl3";

interface TemplateModal_Props {
  isModalOpen: boolean
  closeModal: () => void,
  template?: ReportTemplate
}

export default function TemplateModal({isModalOpen, closeModal, template}:TemplateModal_Props) {
  const {t} = useTranslation()
  const [currentTemplateLevel, setCurrentTemplateLevel] = useState(1);
  const [templateData, setTemplateData] = useState<ReportTemplate|undefined>({name: undefined, dataLevel: undefined, filterParameter: [[]]})
  const mobileXs = useMediaQuery(`(max-width: 690px)`);

  useEffect(() => {
    if (isModalOpen && template) {
      setTemplateData({
        dataLevel: template.dataLevel,
        filterParameter: template.filterParameter,
        dataParameter: template.dataParameter
      });
      setCurrentTemplateLevel(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen])
  
  console.log("template", templateData)

  // Handle template level
  const TemplateLevel = (level: 0 | 1 | 2 | 3) => {
    setCurrentTemplateLevel(level);
  };
  
  // Handle "go back"
  const onGoBack = () => {
    if (currentTemplateLevel === 3) {
      TemplateLevel(2); // Go back to Level 2
    } else if (currentTemplateLevel === 2) {
      TemplateLevel(1); // Go back to Level 1
    } 
  }
    
  return (
    <NewModal 
      modalState={isModalOpen}
      overrides={{ 
        mainContentPadding: MainContentPaddingTypes.secondary,
        headerContentHeight: "65px"
      }}
      predefinedButtons={{
        onClose: closeModal,
        onGoBack: currentTemplateLevel === 2 || currentTemplateLevel === 3? onGoBack : undefined
      }}
      header={t("reportPages.reports.newTemplate", {defaultValue: "new template"})}
      headerContent={
        <ProgressSteps 
          titles={[t("reportPages.reports.dataLevel", {defaultValue: "data level"}), t("reportPages.reports.filterParameter", {defaultValue: "filter parameter"}), t("reportPages.reports.dataParameter", {defaultValue: "data parameter"})]} 
          icons={[glyphs.Animal({}), glyphs.Animal({}), glyphs.Animal({})]} opacityValues={currentTemplateLevel === 1 ? [1, 0.5, 0.5] : currentTemplateLevel === 2 ? [0.5, 1, 0.5] : [0.5, 0.5, 1] }
        />
      }
      secondaryContent={
        <div style={{ width: mobileXs ? "290px" : "615px" }}>
          {currentTemplateLevel === 1 && <TemplateModalLvl1 templateData={templateData} onTemplateDataChange={setTemplateData}/>}
          {currentTemplateLevel === 2 && <TemplateModalLvl2 templateData={templateData} onTemplateDataChange={setTemplateData}/>}
          {currentTemplateLevel === 3 && <TemplateModalLvl3 templateData={templateData} onTemplateDataChange={setTemplateData}/>} 
        </div>}
      mainContent={
        <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
          <Button 
            content={currentTemplateLevel === 1||currentTemplateLevel === 2 ? t("buttons.next", {defaultValue: "next"}) : t("reportPages.reports.createReport", {defaultValue: "create report"})}
            onClick={currentTemplateLevel === 1 ? () => TemplateLevel(2) : currentTemplateLevel === 2 ? () => TemplateLevel(3) : () => closeModal() } // TODO CTO: On closeModal() also save to db/create report
          />
        </div>
      }
    />
  );
}